//  ----------      START   IMPORT  BLOCK       ----------
//  API
import APIService from '../Core/APIService';
//  Config
import API_ROUTES from '../../ConfigFiles/Routes/api_routes';
//  ----------      END   IMPORT  BLOCK       ----------

export default class BusinessHoursService extends APIService {
  async readBusinessHours() {
    const route = API_ROUTES.fetch_business_hours; // Route should be a string/constant if no params
    return this.get(route);
  }

  async updateBusinessHours(dataToSend) {
    return this.put(API_ROUTES.update_business_hours, dataToSend);
  }
}